// extracted by mini-css-extract-plugin
export var markdown = "_v4-0";
export var tableWrapper = "_v4-1";